import { Injectable } from "@angular/core";
import { Inotifier } from "./inotifier";
import { Observable, BehaviorSubject } from "rxjs";

@Injectable()
export class NotifierService implements Inotifier {
	protected _notifier = new BehaviorSubject<any>("");
	constructor() {}

	public get notifier() {
		return this._notifier.asObservable();
	}

	public subscribe(cb: Function) {
		/*this.notifier.subscribe((args)=>{
          cb(args)
        });*/
	}
	public get classname() {
		return (<any>this).constructor.name;
		// OR return (this as any).constructor.name;
	}
}
